module.exports = __webpack_public_path__ + "static/general-liability-2a44a09e0f0e46fe10403a5d474a6640.svg";